/**
 * Weapon types and their properties for the multiplayer deathmatch game
 * Client-side version using ES modules
 */

// Weapon types enum
export const WEAPON_TYPES = {
  KNIFE: 'knife',
  PISTOL: 'pistol',
  MACHINE_GUN: 'machineGun'
};

// Weapon properties
export const WEAPONS = {
  // Knife - melee weapon
  [WEAPON_TYPES.KNIFE]: {
    name: 'Knife',
    damage: 40,        // High damage per hit
    fireRate: 1.5,     // Hits per second
    range: 2,          // Units (melee range)
    ammo: Infinity,    // Unlimited ammo
    reloadTime: 0,     // No reload
    switchTime: 0.3,   // Time in seconds to switch to this weapon
    isMelee: true,     // Is a melee weapon
    automatic: false,  // Not automatic
    model: {
      scale: 0.5,      // Model scale
      position: {      // Position offset from camera
        x: 0.5,
        y: -0.3,
        z: -0.7
      },
      rotation: {      // Rotation in radians
        x: 0,
        y: 0,
        z: 0
      }
    }
  },
  
  // Pistol - semi-automatic, medium damage
  [WEAPON_TYPES.PISTOL]: {
    name: 'Pistol',
    damage: 25,        // Medium damage
    fireRate: 5,       // Shots per second
    range: 100,         // Medium range
    ammo: 12,          // Bullets per magazine
    maxAmmo: 60,       // Maximum reserve ammo
    reloadTime: 1.2,   // Time in seconds to reload
    switchTime: 0.5,   // Time in seconds to switch to this weapon
    isMelee: false,    // Is not a melee weapon
    automatic: false,  // Not automatic (semi-auto)
    model: {
      scale: 0.8,      // Model scale
      position: {      // Position offset from camera
        x: 0.3,
        y: -0.2,
        z: -0.8
      },
      rotation: {      // Rotation in radians
        x: 0,
        y: 0,
        z: 0
      }
    }
  },
  
  // Machine Gun - automatic, lower damage but high fire rate
  [WEAPON_TYPES.MACHINE_GUN]: {
    name: 'Machine Gun',
    damage: 15,        // Lower damage per bullet
    fireRate: 12,      // Shots per second (high fire rate)
    range: 925,         // Longer range
    ammo: 30,          // Bullets per magazine
    maxAmmo: 120,      // Maximum reserve ammo
    reloadTime: 2.0,   // Time in seconds to reload
    switchTime: 0.7,   // Time in seconds to switch to this weapon
    isMelee: false,    // Is not a melee weapon
    automatic: true,   // Automatic fire
    model: {
      scale: 1.0,      // Model scale
      position: {      // Position offset from camera
        x: 0.2,
        y: -0.15,
        z: -0.6
      },
      rotation: {      // Rotation in radians
        x: 0,
        y: 0,
        z: 0
      }
    }
  }
};

// Default starting weapon
export const DEFAULT_WEAPON = WEAPON_TYPES.PISTOL;

// Default starting ammo
export const DEFAULT_AMMO = {
  [WEAPON_TYPES.KNIFE]: Infinity,
  [WEAPON_TYPES.PISTOL]: 12 + 36, // One full magazine + extra ammo
  [WEAPON_TYPES.MACHINE_GUN]: 30 + 60 // One full magazine + extra ammo
};

// Helper to get weapon type by numeric key
export function getWeaponByKey(keyNumber) {
  switch (keyNumber) {
    case 1:
      return WEAPON_TYPES.KNIFE;
    case 2:
      return WEAPON_TYPES.PISTOL;
    case 3:
      return WEAPON_TYPES.MACHINE_GUN;
    default:
      return null;
  }
}

// Helper function to get key for a weapon type
export function getKeyForWeapon(weaponType) {
  switch (weaponType) {
    case WEAPON_TYPES.KNIFE: return 1;
    case WEAPON_TYPES.PISTOL: return 2;
    case WEAPON_TYPES.MACHINE_GUN: return 3;
    default: return null;
  }
} 